import React from 'react';
import { Download } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';

export const DownloadDataModal = ({ open, onOpenChange, onDownload }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-[#050810] border-[#1e2a45]">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-white flex items-center gap-2">
            <Download className="h-5 w-5 text-[#3B82F6]" />
            Download My Data
          </DialogTitle>
          <DialogDescription className="text-gray-400">
            Export your submitted ideas and watchlist
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="bg-[#1e2a45]/50 rounded-xl p-4">
            <h4 className="text-white font-medium mb-3">My Submitted Ideas</h4>
            <div className="flex gap-2">
              <Button
                onClick={() => onDownload('ideas', 'csv')}
                size="sm"
                className="bg-[#3B82F6] text-white text-xs"
              >
                CSV
              </Button>
              <Button
                onClick={() => onDownload('ideas', 'txt')}
                size="sm"
                variant="outline"
                className="border-[#1e2a45] text-gray-300 text-xs"
              >
                TXT
              </Button>
            </div>
          </div>
          <div className="bg-[#1e2a45]/50 rounded-xl p-4">
            <h4 className="text-white font-medium mb-3">My Watchlist</h4>
            <div className="flex gap-2">
              <Button
                onClick={() => onDownload('watchlist', 'csv')}
                size="sm"
                className="bg-[#F97316] text-white text-xs"
              >
                CSV
              </Button>
              <Button
                onClick={() => onDownload('watchlist', 'txt')}
                size="sm"
                variant="outline"
                className="border-[#1e2a45] text-gray-300 text-xs"
              >
                TXT
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
